import { render } from "./DefaultContent2.vue?vue&type=template&id=a6f5f35e"
import script from "./DefaultContent2.vue?vue&type=script&lang=js"
export * from "./DefaultContent2.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\carl.DC_ADVOCATIA\\Documents\\GitHub\\benefit-screening-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__